// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2I8Vv","label":"LabeledBox_label__N35oS"};